import React, { useEffect, useState } from "react";
import Flag from "../assets/static/flag_col.png";
import "../assets/styles/components/Top.sass";

const Top = () => {
  const [link, setLink] = useState({});

  useEffect(() => {
    const LinkSession = window.sessionStorage.getItem("menuV2");

    if (!LinkSession) {
      const LLDDLink = fetch(`https://la-leyenda.com/2018/api/enlace-personalizado/1`);
      const CaribeLink = fetch(`https://la-leyenda.com/2018/api/enlace-personalizado/2`);
      const SeriesManizales = fetch(`https://la-leyenda.com/series-admin-temporal/api/enlace-personalizado/1`);

      Promise.all([LLDDLink, CaribeLink, SeriesManizales]).then(async ([lldd, caribe, seriesManizales]) => {
        const Links = {
          lldd: await lldd.json(),
          caribe: await caribe.json(),
          seriesManizales: await seriesManizales.json(),
        };

        setLink(Links);
        try {
          window.sessionStorage.setItem("menuV2", JSON.stringify(Links));
        } catch (error) {
          return console.log(error);
        }
      });
    }
    setLink(JSON.parse(LinkSession));
  }, []);

  return (
    <div className="row">
      <div className="col-xs-12 Top">
        <div className="hidden-lg Top-burger">
          <a id="menu_mobil" href="#my-menu">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="32px"
              height="25px"
              viewBox="0 0 32 32"
            >
              <rect x="1.599" y="1.731" fill="#000" width="28.803" height="4" />
              <rect x="1.599" y="13" fill="#000" width="28.803" height="4" />
              <rect x="1.599" y="24.268" fill="#000" width="28.803" height="4" />
            </svg>
          </a>
        </div>
        <div>
          <a href="/en/">
            <span className="Top-logo-lldd"></span>
          </a>
        </div>
        <div className="Top-main-menu hidden-xs hidden-sm hidden-md">
          <nav>
            <ul className="Top-menu">
              <li className="Top-lldd">
                <a href="/">
                  LA LEYENDA <br /> DEL DORADO
                </a>
                <div className="Top-lldd-container">
                  <div className="Top-lldd-container-wrap">
                    <b>LA LEYENDA DEL DORADO - 5 STAGE MTB RACE</b>
                    <div className="Top-lldd-grid">
                      <div className="Top-lldd-itema">
                        <a className="Top-lldd-link --red" href={link?.lldd?.url_en}>
                          {link?.lldd?.title_en}
                        </a>
                      </div>
                      <div className="Top-lldd-itemb">
                        <a className="Top-lldd-link" href="/en/contact-us">
                          CONTACT US
                        </a>
                      </div>
                      <div className="Top-lldd-itemc">
                        <p className="text-yellow">HOMEPAGE</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/en/">- La Leyenda Summary</a>
                          </li>
                          <li>
                            <a href="/en/home/packages">- Packages & Upgrades</a>
                          </li>
                          <li>
                            <a href="/en/home/prices">- Prices</a>
                          </li>
                          <li>
                            <a href="/en/home/payment">- Payment Plan</a>
                          </li>
                          <li>
                            <a href="/en/home/categories">- Categories</a>
                          </li>
                          <li>
                            <a href="/en/home/testimonials">- Testimoniales</a>
                          </li>
                          <li>
                            <a href="/en/home/no-excuses">- No Excuses</a>
                          </li>
                          <li>
                            <a href="/en/home/news">- Latest News</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemd">
                        <p className="text-yellow">ABOUT THE RACE</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/en/about-us/race_overview">- Race Overview</a>
                          </li>
                          <li>
                            <a href="/en/about-us/packages-upgrades">- Packages & Upgrades</a>
                          </li>
                          <li>
                            <a href="/en/about-us/categories_and_prizes">- Categories & Prizes</a>
                          </li>
                          <li>
                            <a href="/en/about-us/charity-entries">- Charity Entries</a>
                          </li>
                          <li>
                            <a href="/en/about-us/payment-options">- Payment Options</a>
                          </li>
                          <li>
                            <a href="/en/about-us/rules">- Rules</a>
                          </li>
                          <li>
                            <a href="/en/about-us/social-responsibility">- Social Responsibility</a>
                          </li>
                          <li>
                            <a href="/en/about-us/safety_and_security">- Safety & Security</a>
                          </li>
                          <li>
                            <a href="/en/about-us/travel">- Travel</a>
                          </li>
                          <li>
                            <a href="/en/about-us/tours">- Tours</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-iteme">
                        <p className="text-yellow">ROUTE</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/en/route/2016/summary">- 2016 Guaduas to Retiro</a>
                          </li>
                          <li>
                            <a href="/en/route/2017/summary">- 2017 Caldas</a>
                          </li>
                          <li>
                            <a href="/en/route/2018/summary">- 2018 Caldas</a>
                          </li>
                          <li>
                            <a href="/en/route/2019/summary">- 2019 Caldas</a>
                          </li>
                          <li>
                            <a href="/en/route/2022/summary">- 2022 Valle del Cauca</a>
                          </li>
                          <li>
                            <a href="/en/route/2023/summary">- 2023 Caldas</a>
                          </li>
                          <li>
                            <a href="/en/route/2024/summary">- 2024 Caldas</a>
                          </li>
                          <li>
                            <a href="/en/route/2025">- 2025 Information</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemf">
                        <p className="text-yellow">RACERS</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/en/racers/what_to_pack">- What to Pack</a>
                          </li>
                          <li>
                            <a href="/en/racers/daily_schecdule">- Daily Schedule</a>
                          </li>
                          <li>
                            <a href="/en/racers/tips-and-tricks">- Tips & Tricks</a>
                          </li>
                          <li>
                            <a href="/en/racers/jaguares">- Jaguares</a>
                          </li>
                          <li>
                            <a href="/en/racers/training">- Training</a>
                          </li>
                          <li>
                            <a href="/en/results">- Results</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemg">
                        <p className="text-yellow">SPONSORS & PARTNERS</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/en/sponsors-and-partner">- Sponsors & Partners</a>
                          </li>
                          <li>
                            <a href="/en/sponsors-and-partner/become-a-sponsor">- Become a Sponsor</a>
                          </li>
                          <li>
                            <a href="/en/sponsors-and-partner/expo-information">- Expo Information</a>
                          </li>
                        </ul>
                        <p className="mt-4 d-block text-yellow">NEWS & MEDIA</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/en/latest-news">- Latest News</a>
                          </li>
                          <li>
                            <a href="/en/gallery">- Gallery</a>
                          </li>
                          <li>
                            <a href="/en/videos/2022">- Videos</a>
                          </li>
                          <li>
                            <a href="/en/news-and-media/press">- Press</a>
                          </li>
                          <li>
                            <a href="/en/news-and-media/newsletters">- Newsletters</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemh">
                        <p className="text-yellow">FAQS</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/en/faqs/race-info">- Race Info</a>
                          </li>
                          <li>
                            <a href="/en/faqs/logistics">- Logistics</a>
                          </li>
                          <li>
                            <a href="/en/faqs/registration">- Registration</a>
                          </li>
                          <li>
                            <a href="/en/faqs/services">- Services</a>
                          </li>
                          <li>
                            <a href="/en/faqs/accommodation">- Accommodation</a>
                          </li>
                          <li>
                            <a href="/en/faqs/equipment">- Equipment</a>
                          </li>
                          <li>
                            <a href="/en/faqs/insurance">- Insurance</a>
                          </li>
                          <li>
                            <a href="/en/faqs/cancelation-refunds">- Cancelation & Refunds</a>
                          </li>
                          <li>
                            <a href="/en/faqs/supporters">- Supporters</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-caribe">
                <a href="https://la-leyenda.com/puntacana/en/">
                  LA LEYENDA <br /> PUNTA CANA
                </a>
                <div className="Top-caribe-container">
                  <div className="Top-caribe-container-wrap">
                    <b>LA LEYENDA PUNTA CANA - 5 STAGE MTB RACE - DOMINICAN REPUBLIC</b>
                    <div className="Top-caribe-grid">
                      <div className="Top-caribe-itema">
                        <a className="Top-caribe-link" href={link?.caribe?.url_en}>
                          {link?.caribe?.title_en}
                        </a>
                      </div>
                      <div className="Top-caribe-itemb">
                        <a className="Top-caribe-link" href="https://la-leyenda.com/puntacana/en/contactanos">
                          CONTACT US
                        </a>
                      </div>
                      <div className="Top-caribe-itemc">
                        <p>HOMEPAGE</p>
                        <ul className="Top-caribe-list">
                          <li>
                            <a href="https://la-leyenda.com/puntacana/en/">- La Leyenda Summary</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/en/paquetes-y-ascensos">- Packages & Upgrades</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/en/precios">- Prices</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/en/categorias-y-premiacion">
                              - Categories & prizes
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/en/rutas-y-reglamentacion/resumen">
                              - Routes & rules
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/puntacana/en/patrocinio">- Sponsors</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-caribe-itemd"></div>
                      <div className="Top-caribe-iteme"></div>
                      <div className="Top-caribe-itemf"></div>
                      <div className="Top-caribe-itemg"></div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-series">
                <a href="https://la-leyenda.com/series/en">
                  LA LEYENDA <br /> SERIES
                </a>
                <div className="Top-series-container">
                  <div className="Top-series-container-wrap">
                    <b>LA LEYENDA SERIES - 1 DAY MTB EVENTS</b>
                    <div className="Top-series-grid">
                      <div className="Top-series-itema">
                        <a className="Top-series-link" href="/series/en">
                          HOMEPAGE
                        </a>
                      </div>
                      <div className="Top-series-itemb">
                        <a className="Top-series-link" href="/series/en/contactenos">
                          CONTACT US
                        </a>
                      </div>
                      <div className="Top-series-itemc">
                        <p>ZIPAQUIRA 2025</p>
                        <ul className="Top-series-list">
                          <li>
                            <a href={link?.seriesManizales?.url_en} target="blank">
                              - {link?.seriesManizales?.title_en}
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/zipaquira/acerca-de-la-carrera">
                              - Series Zipaquirá Summary
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/zipaquira/precios-que-incluye">
                              - Prices & What’s Included
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/zipaquira/carrera-manizales">- Routes</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/zipaquira/categorias">- Categories</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/zipaquira/premiacion-y-reglamento">
                              - Prizes & Rules
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/zipaquira/patrocinio-expo">
                              - Sponsorship & Expo
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemd">
                        <p>MANIZALES 2024</p>
                        <ul className="Top-series-list">
                          <li>
                            <a href="https://la-leyenda.com/series/en/manizales/acerca-de-la-carrera">
                              - Series Manizales Summary
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/manizales/categorias">- Categories & Routes</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/manizales/galeria">- Gallery</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/manizales/resultados">- Results</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-iteme">
                        <p>CALDAS 2022</p>
                        <ul className="Top-series-list">
                          {/* <li><a href="https://la-leyenda.com/series/en/caldas/registro">- REGISTER</a></li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/en/caldas/acerca-de-la-carrera">
                              - Series Caldas Summary
                            </a>
                          </li>
                          {/* <li>
                            <a href="https://la-leyenda.com/series/en/caldas/precios-que-incluye">
                              - Prices & What’s Included
                            </a>
                          </li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/en/caldas/categorias-y-rutas">
                              - Categories & Route
                            </a>
                          </li>
                          {/* <li>
                            <a href="https://la-leyenda.com/series/en/caldas/premiacion-y-reglamento">
                              - Prizes & Rules
                            </a>
                          </li> */}
                          {/* <li>
                            <a href="https://la-leyenda.com/series/en/caldas/patrocinio-expo">
                              - Sponsorship & Expo
                            </a>
                          </li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/en/caldas/galeria">- Gallery</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/caldas/resultados">- Results</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemf">
                        <p>CALI 2021</p>
                        <ul className="Top-series-list">
                          {/* <li><a href="https://la-leyenda.com/series/en/cali/registro">- REGISTRO</a></li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/en/cali/acerca-de-la-carrera">
                              - Series Cali Summary
                            </a>
                          </li>
                          {/* <li>
                            <a href="https://la-leyenda.com/series/en/cali/precios-que-incluye">
                              - Prices & What’s Included
                            </a>
                          </li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/en/cali/categorias-y-rutas">- Categories & Route</a>
                          </li>
                          {/* <li>
                            <a href="https://la-leyenda.com/series/en/cali/premiacion-y-reglamento">
                              - Prizes & Rules
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/cali/patrocinio-expo">
                              - Sponsorship & Expo
                            </a>
                          </li> */}
                          <li>
                            <a href="https://la-leyenda.com/series/en/cali/galeria">- Gallery</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/series/en/cali/resultados">- Results</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemf"></div>
                      <div className="Top-series-itemg"></div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-adventures">
                <a href="https://la-leyenda.com/adventures/en/">
                  LA LEYENDA <br /> ADVENTURES
                </a>
                <div className="Top-adventures-container">
                  <div className="Top-adventures-container-wrap">
                    <b> LA LEYENDA ADVENTURES - EXPERTLY ORGANISED, LUXURY CYCLING EXPERIENCES</b>
                    <div className="Top-adventures-grid">
                      <div className="Top-adventures-itema">
                        <a className="Top-adventures-link" href="https://la-leyenda.com/adventures/en/">
                          HOMEPAGE
                        </a>
                      </div>
                      <div className="Top-adventures-itemb">
                        <a className="Top-adventures-link" href="https://la-leyenda.com/adventures/en/contact-us">
                          CONTACT US
                        </a>
                      </div>
                      <div className="Top-adventures-itemc">
                        <a className="Top-adventures-link" href="https://la-leyenda.com/adventures/en/custom-tour">
                          CUSTOM ADVENTURE
                        </a>
                      </div>
                      <div className="Top-adventures-itemd"></div>
                      <div className="Top-adventures-iteme">
                        <p>
                          COFFEE ADVENTURE<span>MTB - Pereira to Pereira</span>
                        </p>
                        <ul className="Top-adventures-list --coffee">
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/coffee-mtb/tour-overview">- Tour Overview</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/coffee-mtb/itinerary/start">- Itinerary</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/coffee-mtb/package-and-price">
                              - Package & Price
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/coffee-mtb/upgrades-and-prices">
                              - Upgrades & Prices
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/coffee-mtb/hotels">- Hotels</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/coffee-mtb/travel-details">
                              - Travel Details
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/coffee-mtb/important-info">
                              - Important Info
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/booknow/coffee-mtb">- BOOK NOW</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-adventures-itemf">
                        <p>
                          ANTIOQUIA ADVENTURE
                          <span>MTB - Medellin to Medellin</span>
                        </p>
                        <ul className="Top-adventures-list --antioquia">
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/antioquia-mtb/tour-overview">
                              - Tour Overview
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/antioquia-mtb/itinerary/start">- Itinerary</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/antioquia-mtb/package-and-price">
                              - Package & Price
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/antioquia-mtb/upgrades-and-prices">
                              - Upgrades & Prices
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/antioquia-mtb/hotels">- Hotels</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/antioquia-mtb/travel-details">
                              - Travel Details
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/antioquia-mtb/important-info">
                              - Important Info
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/booknow/antioquia-mtb">- BOOK NOW</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-adventures-itemg">
                        <p>
                          VOLCANO ADVENTURE<span>MTB - Bogotá to Pereira</span>
                        </p>
                        <ul className="Top-adventures-list --volcano">
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/volcano-mtb/tour-overview">- Tour Overview</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/volcano-mtb/itinerary/start">- Itinerary</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/volcano-mtb/package-and-price">
                              - Package & Price
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/volcano-mtb/upgrades-and-prices">
                              - Upgrades & Prices
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/volcano-mtb/hotels">- Hotels</a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/volcano-mtb/travel-details">
                              - Travel Details
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/volcano-mtb/important-info">
                              - Important Info
                            </a>
                          </li>
                          <li>
                            <a href="https://la-leyenda.com/adventures/en/booknow/volcano-mtb">- BOOK NOW</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        </div>
        <div className="Top-redes">
          <a href="https://la-leyenda.com/">
            <img className="img-responsive" src={Flag} alt="Idioma Español" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Top);
